<!-- 行业分类-详情 -->
<template>
  <div id="detail_accountManage" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">行业详情</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-if="tradeItem.user">
        <div>上级行业名称</div>
        <div>{{tradeItem.user}}</div>
      </div>
      <div v-for="(item,i) in keyItems" :key="i">
        <div>{{item.title}}</div>
        <div v-if="item.type=='status'" class="nowrap" :class="item.class_status?item.class_status[tradeItem[item.key]]:''">
          {{item.text_status[tradeItem[item.key]]?item.text_status[tradeItem[item.key]]:'--'}}</div>
        <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(tradeItem[item.key])}`}}</div>
        <div v-else-if="item.type=='time'" class="nowrap">{{ tradeItem[item.key]?moment(tradeItem[item.key]).format('YYYY-MM-DD'):'--'}}</div>
        <div v-else-if="item.type=='img'" class="nowrap"><img :src="tradeItem[item.key]" width="60" height="60" /> </div>
        <div v-else-if="item.type=='file'" class="nowrap">
          <div v-if="tradeItem[item.key]?.length>0">
            <div v-for="(f,i) in tradeItem[item.key]" :key="i" class="file nowrap" @click="handleFileViewing(f)"> {{f?.name}}</div>
          </div>
          <div v-else style="color:#909399">暂无附件</div>
        </div>
        <div v-else>{{tradeItem[item.key]?tradeItem[item.key]:'--'}}</div>
      </div>
      <div class="smallTitle">行业企业列表</div>
      <div class="table">
        <el-table :data="tradeItem.userList" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table" row-key="id">
          <el-table-column v-for="(item,i) in tableKeys_current" :key="i" :prop="item.key" :label="item.title" :sortable="item.sortable?'custom':false"
            show-overflow-tooltip :min-width="item.width?item.width:''" :align="item.align??'center'">
            <template slot-scope="props">
              <div v-if="item.type=='status'" :class="item.class_status?(item.class_status[props.row[item.key]]):''">
                {{item.text_status[props.row[item.key]]?item.text_status[props.row[item.key]]:'--'}}</div>
              <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}`}}</div>
              <div v-else-if="item.type=='time'" class="nowrap">{{ props.row[item.key]?moment(props.row[item.key]).format('YYYY-MM-DD'):'--'}}
              </div>
              <div v-else class="nowrap">{{props.row[item.key]?props.row[item.key]:'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200" align="center">
            <template #default="scope">
              <el-button type="text" @click.stop="(currentEnterprie= scope.row),(title_dialog='修改企业行业'),(visible_dialog=true)">修改</el-button>
              <el-button type="text" @click.stop="delData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <div slot="empty">
            <img src="../../assets/img/emptyData.png" alt="">
          </div>
        </el-table>
      </div>
      <div class="addRow" @click="(currentEnterprie= {}),(title_dialog='新增企业'),(visible_dialog=true)">+ 行业下新增企业</div>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" plain @click="$router.push({
          path: '/tradeManage/edit',
          query: { id: tradeItem.id,ifEdit:true,tier: tradeItem.tier  }})">编辑</el-button>
      <el-button type="danger" plain @click="delTrade()">删除</el-button>
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
    <!-- 弹窗-编辑企业/新增企业 -->
    <el-dialog class="tradeDialog" top="25vh" :visible.sync="visible_dialog" :title="title_dialog" :destroy-on-close="true" :close-on-press-escape="false"
      :close-on-click-modal="false" :show-close="false" width="370px">
      <!-- 编辑企业 -->
      <el-row v-if="title_dialog.indexOf('修改')>-1">
        <el-col class="flexStart" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="gray" style="margin-right:30px">企业</div>
          <div>{{currentEnterprie.enterprieName}}</div>
        </el-col>
        <el-col class="flexStart" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="gray" style="margin-right:30px">修改前行业</div>
          <div>{{currentEnterprie.category}}</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top:20px">
          <div class="gray">修改后行业<span class="red">*</span></div>
          <el-cascader ref="tradeList" v-model="selected_trade" :options="tradeList" :props="props_cascader" clearable @change="handleChange" size="small"
            style="width:100%"></el-cascader>
        </el-col>
      </el-row>
      <!-- 新增企业 -->
      <el-row v-else>
        <el-row>
          <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">行业ID</el-col>
          <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">{{tradeItem.id}}</el-col>
        </el-row>
        <el-row>
          <el-col :xs="10" :sm="5" :md="5" :lg="5" :xl="5">目前所涉及的行业</el-col>
          <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15">{{tradeItem.name}}</el-col>
        </el-row>
        <el-row style="margin-top:5px">
          <el-input placeholder="请输入内容搜索企业" v-model="queryParam.keyWords" @keyup.enter.native="queryParam.page=1,getUserList()">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-row>
        <div class="treeArea">
          <el-row>
            <el-table :data="enterprieList" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="multipleTable"
              @selection-change="handleSelectionChange" row-key="id">
              <el-table-column :reserve-selection="true" type="selection" width="45"></el-table-column>
              <el-table-column label="企业名称" prop="enterprieName" show-overflow-tooltip></el-table-column>
              <el-table-column label="目前所涉及的行业" prop="category" show-overflow-tooltip></el-table-column>
              <div slot="empty">
                <img src="../../assets/img/emptyData.png" alt="">
              </div>
            </el-table>
          </el-row>
          <!-- 分页 -->
          <div class="pagination">
            <div>共{{total_dialog}}条数据</div>
            <el-pagination hide-on-single-page background @current-change="handleCurrentChange" :current-page.sync="queryParam.page"
              :page-size="queryParam.limit" :pager-count="5" :layout="'prev, pager, next'" :total="total_dialog">
            </el-pagination>
          </div>
          <!-- <el-tree ref="treeList" :props="props_user" :data="enterprieList" :check-strictly='true' node-key="id" :default-expanded-keys="expandedKeys"
            show-checkbox @check-change="handleCheckChange">
          </el-tree> -->
        </div>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit()">确 认</el-button>
        <el-button @click="visible_dialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import PreviewFile from "../../components/file-preview.vue"
export default {
  name: "detail_accountManage",
  components: { PreviewFile },
  data() {
    return {
      moment: moment,
      tradeItem: { userList: [] },
      // 信息字段
      keyItems: [
        { title: "行业名称", key: "name" },
        { title: "行业状态", key: "status", type: 'status', text_status: ['', '启用', '停用'], class_status: ['', 'green', 'red'] },
        { title: "行业描述", key: "describe" },
      ],
      // 列表字段合集
      tableKeys_current: [
        { title: "企业名称", key: "enterprieName", width: 150 },
        { title: "企业联系人", key: "enterprieContacts", width: 150 },
        { title: "企业电话", key: "enterpriePhone", width: 150 },
        { title: "企业邮箱", key: "enterprieMail", width: 150 },
      ],
      visible_dialog: false,
      title_dialog: "修改企业行业",
      currentEnterprie: {},//修改-当前选中企业
      tradeList: [],//修改-行业合集（下拉选择）
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      selected_trade: [],//修改-选中行业
      enterprieList: [],//新增-企业合集
      expandedKeys: [],
      selected_enterprie: [],
      props_user: {
        label: 'enterprieName',
        children: 'userList'
      },
      queryParam: {
        keyWords: "",
        page: 1,
        limit: 5,
      },
      total_dialog: 0
    };
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  created() {
    this.getInfo();
    this.getUserList();
    this.getIndustryTypes();
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    //获取目前所涉及的行业
    getIndustryTypes() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.tradeList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取行业详情
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryInfo`, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 200) {
            this.tradeItem = res.data.data;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取用户列表
    getUserList() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userList`, this.queryParam)
        .then((res) => {
          if (res.data.code === 200) {
            this.enterprieList = Object.assign([], res.data.page.list);
            this.total_dialog = res.data.page.totalCount;
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getUserList();
    },
    handleSelectionChange(val) {
      this.selected_enterprie = val;
    },
    // 获取用户组织树
    getUserList_tree() {
      this.expandedKeys = [];
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userOrganization`,
          { keyWords: '', page: 1, limit: 999999, registerMail: this.currentUser.registerMail || '', tier: this.common.isLogin() || '' })
        .then((res) => {
          if (res.data.code === 200) {
            this.enterprieList = Object.assign([], res.data.page.list);
            if (this.enterprieList.length > 0) {
              this.enterprieList.forEach((e) => {
                if (e.userList && e.userList.length > 0) {
                  this.expandedKeys.push(e.id+'');
                }
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除企业
    delData(item) {
      this.$msgbox({
        title: '删除企业',
        message: '是否确定删除该行业下的企业？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            let url = `${process.env.BASE_URL}api/industry/updateIndustry`,
              param = { id: item.id, category: item.industryCategory }
            param.category = param.category.split(this.tradeItem.id).join("");
            param.category = param.category.split(',,').join(",");
            this.$axios
              .post(url, param).then(res => {
                if (res.data.code == 200) {
                  that.getInfo();
                  that.$message({
                    message: "已删除",
                    type: "success"
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              }).catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).then(action => {
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
          offset: 100
        });
      })

    },
    // 删除行业
    delTrade() {
      this.$msgbox({
        title: '删除行业',
        message: '是否确定删除该行业？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/industry/deleteIndustry`, { id: this.tradeItem.id }).then(res => {
                if (res.data.code == 200) {
                  that.$message({
                    message: "已删除",
                    type: "success"
                  });
                  that.$router.push('/tradeManage')
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              }).catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).then(action => {
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
          offset: 100
        });
      })
    },
    // 修改行业选中操作
    handleChange(val) {
      this.selected_trade = val;
    },
    // 提交-修改企业行业/新增行业企业
    submitEdit() {
      let url = `${process.env.BASE_URL}api/industry/updateIndustry`,
        param = { id: '', category: '' }, ifSubmit = true;
      if (this.title_dialog.indexOf('修改') > -1) {
        if (!this.selected_trade.length) {
          this.$message.warning('请选择行业');
          ifSubmit = false;
        } else {
          // 放置目前所涉及的行业数组
          let industryArr = [];
          this.selected_trade.forEach((arrItem) => {
            industryArr.push(arrItem.join('-'))
          });
          param = { id: this.currentEnterprie.id, category: industryArr.join(',') }
        }
      } else {
        if (!this.selected_enterprie) {
          this.$message.warning('请选择企业');
          ifSubmit = false;
        } else {
          param.id = "";
          this.selected_enterprie.forEach((item) => {
            param.id += item.id + ',';
          });
          param.id = param.id.slice(0, -1);
          param.category = this.tradeItem.parentId ? (this.tradeItem.parentId + '-' + this.tradeItem.id) : this.tradeItem.id;
        }
      }
      if (ifSubmit) {
        this.$axios
          .post(url, param).then(res => {
            if (res.data.code == 200) {
              this.getInfo();
              this.visible_dialog = false;
              this.$message({
                message: "操作成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          }).catch(() => {
          });
      }
    },
    handleCheckChange() {
      this.selected_enterprie = this.$refs.treeList.getCheckedNodes();
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == "ascending" || header.column.order == "descending") {
        return { color: "#3D7BDC", fontSize: "14px", fontWeight: 400 };
      } else {
        return { color: "#617180", fontSize: "14px", fontWeight: 400, background: '#f9fafb' };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: "14px",
        color: "#111928",
        fontWeight: 500,
        padding: "8px 0px",
        background: '#f9fafb'
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  margin-bottom: 45px;
  color: #111928;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 15vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: "";
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
  .smallTitle {
    padding: 8px 15px;
    color: #6b7280;
    width: 200px;
  }
  /deep/.el-table {
    background: #f9fafb;
  }
}
.addRow {
  background: #fff;
  color: rgba(1, 112, 242, 1);
  cursor: pointer;
  text-align: center;
  justify-content: center;
  width: 100vh;
  padding: 5px 0px;
  background: #f9fafb;
}
.treeArea {
  margin: 10px 0px;
  padding: 15px 0px;
  border: 1px solid rgba(220, 220, 220, 1);
  border-radius: 3px;
}
.tradeDialog {
  /deep/.el-dialog__body {
    padding: 10px 20px;
  }
}
</style> 